<template>
  <div class="add-fields-modal">
    <a-modal
      title="分享历史"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleCancel"
      @cancel="handleCancel"
      width="800px"
      :centered="true"
      :footer="null"
      wrapClassName="cont-share"
    >
      <a-tabs type="card" v-model="activeKey" class="page-tabs" @change="changeTag">
        <a-tab-pane key="internal" tab="内部用户"></a-tab-pane>
        <a-tab-pane key="external" tab="外部用户"></a-tab-pane>
        <!-- <a-tab-pane key="media" tab="Media"></a-tab-pane> -->
      </a-tabs>
      <a-form
        ref="form"
        :model="form"
      >
      <a-row :gutter="24">
        <a-col :span="16" >
        <template v-if="activeKey === 'internal'">
          <a-form-item prop="userEmail">
            <a-select
            v-model="form.userEmail"
            :showSearch="true"
            :filter-option="false"
            placeholder="请输入用户关键字进行搜索"
            @search="searchModel"
          >
            <a-select-option v-for="item in tableList" :key="item.loginName" :value="item.loginName">
              <div>{{ item.userName }} <span v-show="item.orgName"> - {{item.orgName}}</span></div>
            </a-select-option>
            </a-select>
          </a-form-item>
        </template>
        <template v-else-if="activeKey === 'external'">
          <a-form-item prop="userEmail">
            <a-input v-model="form.userEmail" placeholder="请填写邮箱进行搜索"></a-input>
        </a-form-item>
        </template>
        <template v-else-if="activeKey === 'media'">
          
        <a-form-item  prop="userEmail">
        <a-select
          v-model="form.userEmail"
          :showSearch="true"
          :filter-option="false"
          placeholder="请输入财务ID关键字进行搜索"
          @search="searchFinanceList"
        >
            <a-select-option v-for="item in financeList" :key="item.advertiserId" :value="item.corporationCode">
              <div>{{ item.advertiserId }} </div>
            </a-select-option>
          </a-select>
         </a-form-item>
        </template>
        </a-col>
        <a-col :span="6">
          <div class="mt-4">
            <a-button type="primary" class="mr-24" @click="getList">查询</a-button>
            <a-button @click="reset">重置</a-button>
          </div>
        </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table
        :columns="columns"
        :row-key="(record, index) => record.id"
        :data-source="data"
        :pagination="pagination"
        size="small"
        :loading="loading"
        @change="handleTableChange"
      >
        <!-- <template slot="index" slot-scope="text, record, index">
          <span>{{index + 1}}</span>
        </template> -->
        <template slot="status" slot-scope="text">
					<div :class="statusEnum(text).class">{{statusEnum(text).text}}</div>
				</template>
         <template slot="userNum" slot-scope="text, record">
          <a-button type="link" @click="handleOpen(record)">{{record.userNum}}</a-button>
          <span style="margin-left: -10px;">
            个
            </span>
        </template>
        <template slot="handle" slot-scope="text, record">
					<div class="table-handle-btn">
            <a-button type="link" @click="changeStatus(record)">
              <template v-if="record.status === 1">
                
                <icon-font class="edit-btn" type="icon-Close-Circle"/>
                取消分享
              </template>
              <template v-else-if="record.status === 0">
                <icon-font class="edit-btn" type="icon-Share"/>
                分享
              </template>
            </a-button>
					</div>
				</template>
        <template slot="check" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="changeStatus(record)" />
				</template>
        <template slot="edit" slot-scope="text, record">
          <a-switch v-if="record.shareOrgId == ''" :checked="record.permission?.indexOf('w') > -1" @change="editChange(record)" />
				</template>
      </a-table>
      </div>
    </a-modal>
    <orgInfo ref="orgInfo" :id="currentId"></orgInfo>
  </div>
</template>
<script>
import { shareHistory, switchShare, getUserNames, getFinanceIdList, switchEdit } from "@/api/shareModal"
import orgInfo from "./orgInfo"
const innerColumns = [
	{
		title: '姓名',
		dataIndex: 'username',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'username' },
	},
	{
		title: '部门',
		dataIndex: 'orgName',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'orgName' },
	},
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 130,
    scopedSlots: { customRender: 'status' },
  },
	{
		title: '分享时间',
		dataIndex: 'createTime',
		align: 'left',
    ellipsis: true,
		width: 150,
    scopedSlots: { customRender: 'createTime' },
	},
  {
		title: '查看',
		dataIndex: 'check',
		align: 'left',
		scopedSlots: { customRender: 'check' },
		width: 70,
	},
  {
    title: '编辑',
		dataIndex: 'edit',
		align: 'left',
		scopedSlots: { customRender: 'edit' },
		width: 70,
  }
]
const outColumns = [
	{
		title: '邮箱',
		dataIndex: 'userEmail',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'userEmail' },
	},
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 130,
    scopedSlots: { customRender: 'status' },
  },
	{
		title: '分享时间',
		dataIndex: 'createTime',
		align: 'left',
    ellipsis: true,
		width: 150,
    scopedSlots: { customRender: 'createTime' },
	},
  {
		title: '操作',
		dataIndex: 'handle',
		align: 'left',
		scopedSlots: { customRender: 'handle' },
		width: 150,
	},
]
const mediaColumns = [
	{
		title: '企业编码',
		dataIndex: 'userEmail',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'userEmail' },
	},
	{
		title: '企业名称',
		dataIndex: 'orgName',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'orgName' },
	},
	{
		title: '企业用户数',
		dataIndex: 'userNum',
		align: 'left',
    ellipsis: true,
		width: 110,
    scopedSlots: { customRender: 'userNum' },
	},
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 100,
    scopedSlots: { customRender: 'status' },
  },
	{
		title: '分享时间',
		dataIndex: 'createTime',
		align: 'left',
    ellipsis: true,
		width: 150,
    scopedSlots: { customRender: 'createTime' },
	},
  {
		title: '操作',
		dataIndex: 'handle',
		align: 'left',
		scopedSlots: { customRender: 'handle' },
		width: 150,
	},
]
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      loading: false,
      pagination: {
				current: 1,
				total: 0,
				pageSize: 1000,
        showTotal: total => `共${total}条`
			},
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      form:{
        userEmail: undefined,
      },
      activeKey: 'internal',
			data: [],
			columns: innerColumns,
      tableList: [],
      financeList: [],
      currentId: ''
    };
  },
  components: {
    orgInfo,
  },
  props:{
    record: {
      type: Object,
      default: () => {}
    }
  } ,
  watch:{
    visible(val){
      if(val){
        this.getList();
      }
    }
  },
  mounted() {
    
    // this.getList();
  },
  methods: {
    editChange(record) {
      const status = record.permission?.indexOf('w') > -1 ? 0 : 1;
      switchEdit(record.id, status).then((res) => {
				this.$message.success('更改成功！')
				if(this.data.length === 1) {
					this.pagination.current = 1
				}
				this.getList()
        if(this.activeKey === 'media'){
          this.$emit('refreshList')
        }
      })
    },
    searchModel(val){
      this.fetchModel(val);
    },
    fetchModel(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getModelList(val);
      }, 500);
    },
    getModelList(userName) {
      this.loading = true
      getUserNames({
        userName
      }).then((res) => {
        this.tableList = this.$deepclone(res.data) || []
      }).finally(() => this.loading = false)
    },
    statusEnum(text) {
			let obj = this.$enum.SHARE_STATUS[text] || { class: "", text: "" }
			return obj
		},
    searchFinanceList(val){
      this.fetchFinanceList(val);
    },
    handleOpen(record){
      this.currentId = record.userEmail;
      this.$refs.orgInfo.visible = true;
    },
    fetchFinanceList(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getFinanceList(val);
      }, 500);
    },
    getFinanceList(searchKeyWord) {
      this.loading = true
      getFinanceIdList({
        searchKeyWord
      }).then((res) => {
        this.financeList = this.$deepclone(res.data) || []
      }).finally(() => this.loading = false)
    },
   getList() {
      this.loading = true
      const params = {
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        type: this.activeKey,
        templateId: this.record.analysisTemplateId,
        userEmail: this.form.userEmail
      }
      shareHistory(params).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(pagination) {
			let pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.getList()
		},
    changeStatus(record){
      const params = {id : record.id, status: record.status}
      const status = record.status ? 0 : 1;
      switchShare(record.id, status).then((res) => {
				this.$message.success('更改成功！')
				if(this.data.length === 1) {
					this.pagination.current = 1
				}
				this.getList()
        if(this.activeKey === 'media'){
          this.$emit('refreshList')
        }
      })
    },
    changeTag(val){
      if(val === 'internal'){
        this.columns = innerColumns;
      }else if(val === 'external'){
        this.columns = outColumns;
      }else if(val === 'media'){
        this.columns = mediaColumns;
      }
      this.reset();
      this.getList();
    },
    handleOk(e) {
      
    },
    reset(){
      this.form.userEmail = undefined;
      this.pagination.current = 1;
      this.getList();
    },
    handleCancel(e) {
      
      this.visible = false;
    },
    

  },
  
};
</script>
<style lang="less" scoped>
/deep/ .cont-share .ant-modal-body{
  padding-top: 0;
}
.division-title {
  text-align: left;
  line-height: 40px;
  padding-right: 10px;
}
.use-popover{
  // background: #f90;
}
.success {
		line-height: 22px;
		background: #F2FAF3;
		border-radius: 4px;
		font-size: 12px;
		color: #22AC35;
		padding: 0 8px;
		display: inline-block;
	}
  .cancel {
		line-height: 22px;
		background: #F3F6FE ;
		border-radius: 4px;
		font-size: 12px;
		color: #677392;
		padding: 0 8px;
		display: inline-block;
	}
  .page-tabs {
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>